import { createAction } from '@gef-ui/utils/fsaActions';
import invariant from 'invariant';
import keyMirror from "ramda-extension/es/keyMirror";
import { getFormData, getFormFieldState, getFormFieldValue, getFormState, getFormStream, getGlobalErrors, getIsFormPristine, sendControlNext } from '../../stream/streamStorage';
export const actionNames = keyMirror({
    SEND_TO_RX_FORM_CONTROL: null
});
/**
 * send action to rx form control
 *
 * @documented
 * @category ReduxStreamStorage
 * @import import { sendToRxFormControl } from '@gef-ui/form-core/redux/streamStorage'
 * @param {Object} controlAction - action from `stream/transfer/control`
 * @param {String} formName
 * @example
 *
 * 	sendToRxFormControl({ formName: 'example', controlAction: { type: 'SOME_ACTION'} })
 *
 */ export const sendToRxFormControl = createAction(actionNames.SEND_TO_RX_FORM_CONTROL);
/**
 * exposed actions from stream storage to thunk
 *
 * @documented
 * @category ReduxStreamStorage
 * @import import { thunkApi } from '@gef-ui/form-core/redux/streamStorage'
 * @example
 *
 * 	withExtraArgument(thunkApi)
 *
 */ export const thunkApi = {
    getFormStream,
    getFormData,
    getFormState,
    getIsFormPristine,
    getFormFieldValue,
    getGlobalErrors,
    getFormFieldState,
    sendControlNext
};
export const streamStorageMiddleware = ()=>(next)=>(action)=>{
            if (action.type === actionNames.SEND_TO_RX_FORM_CONTROL) {
                const { controlAction, formName } = action.payload;
                const { control$ } = getFormStream(formName);
                invariant(control$, `cannot find stream for ${formName}`);
                control$.next(controlAction);
            } else {
                next(action);
            }
        };
